import type { Cpc25Report } from '../../../../types/LegalCase';

// Geração do CSV do relatório consolidado CPC 25 (sem lib externa). Uma linha por
// entidade × polo × classificação, mais colunas de perda estimada e provisão. Puro e
// testável; o disparo do download fica no componente.

const HEADER = [
    'Entidade credora',
    'Polo',
    'Classificacao',
    'Numero de casos',
    'Perda estimada (R$)',
    'Provisao (R$)',
    'Fora do padrao',
    'Ajustados manualmente',
];

// Escapa um campo para CSV: aspas duplas ao redor e duplica aspas internas. Sempre entre
// aspas para não quebrar com vírgula/; no separador nem com o ponto/vírgula do número BR.
const escape = (value: string | number): string => {
    const s = String(value ?? '');
    return `"${s.replace(/"/g, '""')}"`;
};

// Número no formato BR (1234.5 -> "1234,50") sem símbolo de moeda — o Excel pt-BR entende.
const money = (value: number): string => value.toFixed(2).replace('.', ',');

export const buildCpc25Csv = (report: Cpc25Report): string => {
    const lines: string[] = [HEADER.map(escape).join(';')];

    for (const entity of report.entities) {
        for (const pole of entity.poles) {
            for (const row of pole.rows) {
                lines.push([
                    escape(entity.creditorEntity),
                    escape(pole.poleFormatted),
                    escape(row.classificationFormatted),
                    escape(row.count),
                    escape(money(row.estimatedLoss)),
                    escape(money(row.provision)),
                    escape(row.offSuggestion),
                    escape(row.overridden),
                ].join(';'));
            }
        }
    }

    // Linha de total geral.
    const s = report.summary;
    lines.push([
        escape('TOTAL'), escape(''), escape(''),
        escape(s.count), escape(money(s.estimatedLoss)), escape(money(s.provision)),
        escape(s.offSuggestion), escape(s.overridden),
    ].join(';'));

    return lines.join('\n');
};

// Nome do arquivo com a data do dia (yyyy-mm-dd), para não sobrescrever exports anteriores.
export const cpc25CsvFilename = (today: Date = new Date()): string => {
    const iso = today.toISOString().slice(0, 10);
    return `relatorio-cpc25-${iso}.csv`;
};
